export const IAndILegend = () => (
	<div className="space-y-2">
		<div className="space-y-1">
			<div className="flex justify-between text-[10px] text-gray-500">
				<span>Low</span>
				<span>High</span>
			</div>
			<div
				className="h-2.5 rounded-full"
				style={{ background: "linear-gradient(to right, #00FF00, #FFFF00, #FF0000)" }}
			/>
		</div>
		<div className="flex items-center gap-2">
			<span className="inline-block h-2.5 w-2.5 rounded-full shrink-0 bg-gray-400" />
			<span className="text-xs text-gray-500">No data</span>
		</div>
	</div>
);
